import {
    FaqElementPropertyOnboardingManifestV1,
    FastTrackLearnMoreElementPropertyOnboardingManifestV1,
    FirstBookingElementPropertyOnboardingManifestV1,
    FooterSectionElementPropertyOnboardingManifestV1,
    HeroSectionElementPropertyOnboardingManifestV1,
    ListYourPropertyElementPropertyOnboardingManifestV1,
    PartnerAllYouHaveToDoSectionElementPropertyOnboardingManifestV1,
    PartnerMarketingContactUsElementPropertyOnboardingManifestV1,
    SelectLanguageElementPropertyOnboardingManifestV1,
    SignInElementPropertyOnboardingManifestV1,
    SiteMapSectionElementPropertyOnboardingManifestV1,
    StartImportMyPropertyElementPropertyOnboardingManifestV1,
    SupportSectionElementPropertyOnboardingManifestV1,
    WhyAgodaCardElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    type PartnerMarketingPagePropertyOnboardingContextFieldsV1,
    type PartnerMarketingPagePropertyOnboardingContextIdsV1,
    PartnerMarketingPagePropertyOnboardingContextManifestV1,
    WebPartnerMarketingVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/partner-marketing-page";
import { BaseContextFieldsMapping, GetAttributeNumberSafe } from "../functions/appContext";
import { defineBinder } from "../functions/defineBinder";

export const partnerMarketingBinder = defineBinder(({ webAnalytics, action: { hover, click, reveal } }) => {
    webAnalytics.pageContext<
        PartnerMarketingPagePropertyOnboardingContextIdsV1,
        PartnerMarketingPagePropertyOnboardingContextFieldsV1
    >(PartnerMarketingPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebPartnerMarketingVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], SignInElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], SelectLanguageElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([hover], FirstBookingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, hover], ListYourPropertyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], HeroSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], PartnerAllYouHaveToDoSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], FastTrackLearnMoreElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal, hover], WhyAgodaCardElementPropertyOnboardingManifestV1.ids, {
        action_element_index: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-why-agoda-card"),
    });
    webAnalytics.observeElement([click, reveal], FaqElementPropertyOnboardingManifestV1.ids, {
        action_element_index: (element: HTMLElement) => GetAttributeNumberSafe(element, "data-faq-element"),
    });
    webAnalytics.observeElement([reveal], SupportSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], PartnerMarketingContactUsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], SiteMapSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([reveal], FooterSectionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], StartImportMyPropertyElementPropertyOnboardingManifestV1.ids, {});
});
